export default {
  // 支付结果页面
  result: {
    title: 'Payment Result',
    success: {
      title: 'Payment Successful',
      message: 'The payment is successful, please close the page.',
      loading: 'Loading...'
    },
    failed: {
      title: 'Payment Failed',
      message: 'Payment failed, please close the page and try again.'
    }
  },
  
  // 通用支付相关
  common: {
    loading: 'Loading...',
    close: 'Close',
    tryAgain: 'Try Again',
    back: 'Back'
  }
};
